import en from './en'
import es from './es'
import { LANG_EN, LANG_ES } from '../config/LanguageConfig'

const messages = {
    [LANG_EN]: en,
    [LANG_ES]: es,
}

export default messages
